"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBase = void 0;
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const ObservableEntity_1 = require("./ObservableEntity");
class DialogBase extends ObservableEntity_1.ObservableEntity {
    get isOpen() {
        return this.memoizedOpen.val;
    }
    set isOpen(open) {
        this.memoizedOpen.val = open;
    }
    constructor(type) {
        super();
        this.preventOutsideDismiss = true;
        this.memoizedOpen = new MemoizedBoolean_1.MemoizedBoolean(false, this.notify);
        this.type = type;
    }
}
exports.DialogBase = DialogBase;
